import * as React from 'react';
import { COLOR_B } from './CONSTANTS';

const useTouchEvents = 'ontouchstart' in window || navigator.msMaxTouchPoints > 0;

const LooperView = ({ startLoopRec, stopLoopRec, clearLoop, status }) => {
	const buttonStyle = {
		height: '100%',
		padding: '10%',
		width: '100%',
		textAlign: 'center',
		background: COLOR_B,
		margin: 'auto',
	};

	return (
		<React.Fragment>
			{(() => {
				var action, label;
				if (status === 'CLEAR') {
					action = startLoopRec;
					label = 'start loop';
				}
				if (status == 'REC') {
					action = stopLoopRec;
					label = 'stop loop';
				}
				if (status == 'PLAYING') {
					action = clearLoop;
					label = 'clear loop';
				}
				return (
					<div
						style={buttonStyle}
						onClick={!useTouchEvents ? action : null}
						onTouchStart={useTouchEvents ? action : null}
					>
						<p>{label}</p>
					</div>
				);
			})()}
		</React.Fragment>
	);
};

export default LooperView;
